import { RequestResponse } from '@/common/types_and_interfaces.ts'
import { z } from 'zod'
import axiosInstance from '@/libs/axios_config.ts'
import { parseRequestError } from '@/common/utilities.ts'

export const ProgramYearSchema = z.object({
  id: z.number(),
  name: z.string(),
  program_start_date: z.string(),
  program_end_date: z.string(),
  year_type: z.enum(['past', 'current', 'upcoming'])
})

export type ProgramYear = z.infer<typeof ProgramYearSchema>

export type ProgramYearResponse = ProgramYear[]

export async function GETApplicantSchoolYears(): Promise<RequestResponse<ProgramYearResponse>> {
  try {
    const response = await axiosInstance.get(`/scholar/programs`, {})
    return {
      data: z.array(ProgramYearSchema).min(1).parse(response.data),
      error: null,
    }
  } catch (e) {
    return { error: parseRequestError(e), data: null }
  }
}